import { useState } from "react";
import ShellCard from "../../components/ShellCard";
import heroBanner from "../../assets/images/pages/dui-level1.jpg";
import "./FourHourBDI.css";

const CursoDeDUIEnEspanol = () => {
    const [username, setUsername] = useState("");

    const handleLogin = (e) => {
        e.preventDefault();
        const baseUrl = "https://dui.webwizardsusa.com/login";
        const redirectUrl = username ? `${baseUrl}?username=${encodeURIComponent(username)}` : baseUrl;
        window.location.href = redirectUrl;
    };

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${heroBanner})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">Curso de DUI en Español</h1>
                            <p className="banner-subheading">Programa de DUI</p>
                        </div>
                    </div>
                </div>
            </section >

            <main className="bdi-page mb-3">
                <div className="container mt-5">
                    <div className="row">
                        <div className="col-12 col-lg-7 mb-4">
                            <ShellCard>
                                <h3 className="mb-4 text-warning">
                                    Programa de DUI
                                </h3>

                                <p className="mb-3">
                                    El programa de DUI consiste de horas de clase y una evaluación de una hora. El registro por internet le permitirá elegir su horario de clases.
                                </p>

                                <p className="mb-3">
                                    Al completar el proceso de registro, usted recibirá un correo electrónico con todo lo que necesita saber acerca del programa de DUI. Vamos a necesitar una copia firmada de estos documentos.
                                </p>

                                <p className="mb-3">
                                    Se puede registrar para el programa de DUI por internet, por teléfono o en persona en una de nuestras oficinas.
                                </p>

                                <p className="mb-3">
                                    Las clases y evaluaciones están disponibles en inglés y español. A pesar de que el proceso de registro es en inglés, tendrás la opción de seleccionar una clase en español.
                                </p>

                                <p className="mb-4">
                                    Para iniciar su registro por internet, por favor:
                                </p>

                                <div className="d-flex flex-wrap justify-content-start gap-3">
                                    <a
                                        href="https://dui.webwizardsusa.com/register"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-primary text-decoration-none"
                                        style={{ minWidth: "200px" }}
                                    >
                                        ¡Regístrese Ahora!
                                    </a>
                                </div>
                            </ShellCard>
                        </div>

                        <div className="col-12 col-lg-5 mb-4">
                            <ShellCard>
                                <h3 className="mb-4 text-warning">
                                    Información de Cómo Entrar en el Sistema
                                </h3>
                                <p className="text-muted mb-4">
                                    Cómo entrar en el sistema del Programa de DUI
                                </p>

                                <form onSubmit={handleLogin}>
                                    <div className="mb-3">
                                        <label htmlFor="username" className="form-label text-white">
                                            Nombre de Usuario
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="username"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            style={{
                                                backgroundColor: "#333",
                                                border: "1px solid #444",
                                                color: "#fff",
                                            }}
                                        />
                                    </div>
                                    <div className="d-grid">
                                        <button
                                            type="submit"
                                            className="btn metro-btn-secondary fw-bold text-uppercase"
                                        >
                                            Login
                                        </button>
                                    </div>
                                </form>
                            </ShellCard>
                        </div>
                    </div>
                    <div className="row p-3">
                        <p>Superb Customer Service</p>
                        <p>At Metro we always aim to provide an exceptional and pain free educational experience. We do this by only offering state approved courses that use cutting edge technology and always providing first rate customer service. Here are some reviews left by past clients!</p>
                    </div>
                </div>
            </main>
        </>
    );
};

export default CursoDeDUIEnEspanol;
